import React from 'react'

import { BlockComponent } from 'common/builder/components/chart/FlowChart/components/Block/types'
import { Button } from 'common/builder/components/chart/FlowChart/components/Button/Button'
import { ContentContainer } from 'common/builder/components/chart/FlowChart/components/ContentContainer/ContentContainer'
import { InteractiveBlockContainer } from 'common/builder/components/chart/FlowChart/components/InteractiveBlockContainer/InteractiveBlockContainer'
import { FlowChartListMessageBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartListMessageBlock'

import * as styles from './ListMessage.styles'
import { ListMessageContent } from './ListMessageContent'

export const ListMessageBlock: BlockComponent<FlowChartListMessageBlock> = ({ block }) => {
  return (
    <InteractiveBlockContainer id={block.id}>
      <ContentContainer>
        <view style={styles.contentWrapper}>
          <ListMessageContent blockData={block.data} />
        </view>
        <Button button={block.data.button} />
        <view style={styles.separator} />
        {block.data.sections.map((section) => (
          <view key={section.id} style={styles.sectionWrapper}>
            <richtext style={styles.sectionTitle} text={section.title} />
            {section.buttons.map((button) => (
              <Button button={button} key={button.id} />
            ))}
          </view>
        ))}
      </ContentContainer>
    </InteractiveBlockContainer>
  )
}
